import plataformaApi from '@/services/plataforma/default';

export default {
  async fetchLanguages({ commit }) {
    await plataformaApi.get('academic/language').then(response => {
      commit('SET_LANGUAGE_OPTIONS', response.data.languages);
    });
  }
};
